import { MessagingProvider } from '@src/model/frontendmodel';
import type { LinkedPhone } from '@src/reducers/contactRToolkit';
import type { RootState } from '@src/store/reduxstore';
import { ResponseStatus } from '@src/types/chats';
import { GeneralContactInfo } from '@src/types/contact';
import { ContactBotAccount, Selector } from '@types';

type ContactState = {
  contacts?: {
    conversation?: {
      availableMessaginAccount?: ContactBotAccount[];
      // availableMessaginAccount?: TemplatedMsgWrapper[];
    };
  };
};

export const getActiveChatContactInfo: Selector<GeneralContactInfo> = (
  state: RootState
) => state.agentConsole?.contact?.contact;

/** Phone linked live through a REQUEST_CONTACT_INFO request (`CONTACT_PHONE_LINKED`). */
export const linkedPhoneSelector = (state: RootState): LinkedPhone | null =>
  state.agentConsole?.contact?.linkedPhone ?? null;

export const contactExistsStatusSelector =
  (mobilePhone: string): Selector<ResponseStatus> =>
  (state: RootState) =>
    state.contactVCard?.contactExists[mobilePhone]?.status;

export const selectContactBotAccounts = (
  state: RootState
): ContactBotAccount[] | undefined => {
  const contactState = state.adminHome.contact as ContactState;

  return contactState?.contacts?.conversation?.availableMessaginAccount?.filter(
    item => item.provider === MessagingProvider.WHATSAPPB2CHAT
  );

  // state.adminHome.contact.contacts.conversation.availableMessaginAccount
};

export default getActiveChatContactInfo;
